"use client";

import { useRouter } from "next/navigation";
import { useCallback } from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import { withLocalePrefix, pathnameToCanonical } from "@/lib/i18nRouting";
import { usePathname } from "next/navigation";

/**
 * `router.push` / `replace` with paths interpreted as canonical (no `/en`),
 * then prefixed for the current UI locale.
 */
export function useLocalizedRouter() {
  const router = useRouter();
  const pathname = usePathname();
  const { locale } = useLanguage();

  const push = useCallback(
    (canonicalHref: string) => {
      const target = withLocalePrefix(locale, canonicalHref);
      router.push(target);
    },
    [locale, router]
  );

  const replace = useCallback(
    (canonicalHref: string) => {
      const target = withLocalePrefix(locale, canonicalHref);
      router.replace(target);
    },
    [locale, router]
  );

  /** Current path as canonical (strip `/en`) for comparisons. */
  const canonicalPath = pathnameToCanonical(pathname);

  return { push, replace, canonicalPath, pathname, router };
}
